module.exports = __webpack_public_path__ + "img/university-hair-logo.da85dc7f.jpg";